<style>
    .popup-main {
        height: 100%;
    }
    .popup-content {
        height: 100%;
    }
    .overview-map {
        height: 100%;
    }
    .overview-map .map {
        height: 100%;
    }
</style>
<script lang="ts">
    export default {
        name: 'MapHost',

        props: [
            'type',
            'url'
        ],

        render() {},

        data() {
            return {
                boundMethods: {}
            };
        },

        created() {
            const reference = 'overview-map';

            this.boundMethods.openHandler = () => {
                this.Bus.emit('build-popup', {
                    reference,
                    data: {
                        type: this.type,
                        url: this.url
                    },
                });
            };

            this.boundMethods.openedPopup = ref => {
                if (ref !== reference) {
                    return;
                }

                this.moveFilters();
            };

            this.boundMethods.closedPopup = ref => {
                if (ref !== reference) {
                    return;
                }

                this.moveFiltersBack();
            };

            this.Bus.on('open-maps-popup', this.boundMethods.openHandler);
            this.Bus.on('popup-opened', this.boundMethods.openedPopup);
            this.Bus.on('popup-closed', this.boundMethods.closedPopup);
        },

        methods: {
            moveFilters() {
                this.Bus.emit('filter-portal-activate');
            },

            moveFiltersBack() {
                this.Bus.emit('filter-portal-revert');
            },
        }
    };
</script>
